import { AdminMultiSelect, type MultiSelectItem } from "@/admin/AdminMultiSelect.tsx";
import type { AdminHostPoolWithType } from "@/admin/host_pools/hostPoolsQuery.ts";

export interface AdminHostPoolMenuProps {
    value: string[];
    pools: AdminHostPoolWithType[];
    canUnselectAll?: boolean;
    onChange: (value: string[]) => void;
}

export function AdminHostPoolMenuContent({ value, pools, onChange, canUnselectAll = true }: AdminHostPoolMenuProps) {
    const items = pools.map(
        (pool): MultiSelectItem => ({
            id: pool.uuid,
            title: `${pool.name} (${pool.location})`,
        }),
    );

    return <AdminMultiSelect items={items} value={value} onChange={onChange} canUnselectAll={canUnselectAll} />;
}
